import { CreateOperationAttr } from "./OperationAttr";
import { Operation } from "./OperationBase";
import {CreateOperationContent, OperationContent} from "./OperationContent";
import {ComponentType} from "./ContentComponent";

type PlaceHolder = {
  path:number[],
  CreateOp:(node:HTMLElement,curComp:ComponentType,args:any[])=>Operation|null
}

export class HtmlBuilder {
  #phs:PlaceHolder[]=[];
  #tmpl=document.createElement("template");

  constructor(fixed:TemplateStringsArray) {
    let x="";
    for(let i=0;i<fixed.length-1;i++) {
      x +=fixed[i];
      x +=this.#InAttr(x) ? '{{fv' + i + '}}' : '<!--{{fv' + i + '}}-->'; 
    }
    x+=fixed[fixed.length-1];
    this.#tmpl.innerHTML=x;
    this.#FillPlaceHolders(this.#tmpl.content,[]);     
  }

  #InAttr(x:string) {
    return x.lastIndexOf("<") > x.lastIndexOf(">");
  }

  // is a function because it needs to call itself recursively
  #FillPlaceHolders(node:Node,path:number[]) {
    let cn:Node,x:string,k:number,fvID:number,attr:Attr,cnPath:number[];
    for(let i=0;i<node.childNodes.length;i++) {
      cn=node.childNodes[i];
      cnPath=path.concat(i);
      if(cn.nodeType===1) { //element
        let cne=<HTMLElement>cn;
        // if this is a <select> element - process children first - cannot set value before children present
        if(cne.tagName.toLowerCase()==="select") this.#FillPlaceHolders(cn,cnPath);
        let classSC:{class:string,argidx:number}[]=[];
        let dirPhs:PlaceHolder[]=[];
        let gotClass=false;
        for(let j=0; j<cne.attributes.length;j++) {
          attr=cne.attributes[j];
          if(attr.name==="class") {
            if(classSC.length>0) throw new Error("Katla: Cannot combine 'class' and 'class:...' attributes on same element");
            gotClass=true;
          }
          x=attr.value;
          k=x.indexOf("{{fv");
          if(k<0){
            if(attr.name.startsWith("class:")) throw new Error("Katla: " + attr.name + " attribute must have ${boolean} value");
            if(attr.name.charAt(0)==="#" || attr.name.charAt(0)===".") {
            // fixed value special attribute 
              (attr.name.charAt(0)==="#"?dirPhs:this.#phs).push(CreatePlaceholderAttrStatic(cnPath,attr.name,x)); // 1=static value
              cne.removeAttribute(attr.name);
              j-=1;
            }
            continue;
          }
          let va:(string|number)[]=[];
          while(k>=0) {
            if(k>0) va.push(x.substr(0,k));
            x=x.substr(k+4)
            k=x.indexOf("}}");
            if(k<0) throw new Error("Katla: Unexpected missing }}");
            fvID=parseInt(x.substr(0,k));
            va.push(fvID);
            x=x.substr(k+2);
            k=x.indexOf("{{fv");
          }
          if(x.length>0) va.push(x);
          if(va.length===1) {
            // simple attribute (type 2)
            if(attr.name.startsWith("class:")) {
              if(gotClass) throw new Error("Katla: Cannot combine 'class' and 'class:...' attributes on same element");
              classSC.push({class:attr.name.substr(6),argidx:<number>(va[0])})
            } else {
              (attr.name.charAt(0)==="#"?dirPhs:this.#phs).push(CreatePlaceholderAttrDynamic(cnPath, attr.name, <number>(va[0]))); 
            }
          } else {
            if(attr.name.startsWith("class:")) throw new Error("Katla: " + attr.name + " attribute must have ${boolean} value");
            // concat attribute (type 3)
            (attr.name.charAt(0)==="#"?dirPhs:this.#phs).push(CreatePlaceholderAttrConcat(cnPath,attr.name,va)); 
          }
          cne.removeAttribute(attr.name);
          j-=1;
        }
        if(classSC.length>0) this.#phs.push(CreatePlaceholderAttrClasses(cnPath,classSC)); 
        // add placeholders for directives (attr.name start with #) last - so other attributes are set before directives run
        this.#phs.push(...dirPhs);
        if(cne.tagName.toLowerCase()!=="select") this.#FillPlaceHolders(cn,cnPath);

      } else if (cn.nodeType===8) { //nodeType 8 = comment
        let cnc=<Comment>cn;
        if(cnc.data.substr(0,4)==="{{fv") {
          fvID=parseInt(cnc.data.substr(4,cnc.data.length-6));
          if(node.childNodes.length==1) {
            cnc.remove();
            this.#phs.push(CreatePlaceholderContent(path,fvID,true));
          } else {
            cnc.data="";
            node.insertBefore(document.createComment(""),cn);
            this.#phs.push(CreatePlaceholderContent(cnPath,fvID,false));
            i+=1;
          }
        }
      }
    }
  }

  MakeLive(args:any[],curComp:ComponentType) {
    let cl=this.#tmpl.content.cloneNode(true); 
    let ops=this.#phs.map(ph=>{
      // get all nodes first - because ph.CreateOp will insert new node - changing indexes
      let n=cl;
      ph.path.forEach(idx=>n=n.childNodes[idx])
      return {ph,n};
    }).map(itm=> itm.ph.CreateOp(<HTMLElement>(itm.n),curComp,args)).filter(op=>op!==null);

    //oc.SetContent(cl);
    return {ContentNode: cl,
            Update: (args:any[])=>{for(const op of ops) op.Update(op.GetData(args))},
            Unload: ()=> {for(const op of ops) op.Unload()}};
  }
}



function CreatePlaceholderAttrStatic(path:number[],name:string,value:string):PlaceHolder {
  return {
    path:path,
    CreateOp(node:HTMLElement,curComp:ComponentType,args:any[]):Operation|null {
      let getVal=(args:any[])=>value;
      // this is executed also for static - because it initializes the attribute with the static value
      CreateOperationAttr(node,name, getVal,curComp, getVal(args)); 
      return null;
    }
  }
}

function CreatePlaceholderAttrDynamic(path:number[],name:string,value:number):PlaceHolder {
  if(name.startsWith("_")) name=name.substring(1);
  return {
    path:path,
    CreateOp(node:HTMLElement,curComp:ComponentType,args:any[]):Operation|null {
      let getVal=(args:any[])=>args[value];
      return CreateOperationAttr(node,name, getVal, curComp, getVal(args)); 
    }
  }
}

function CreatePlaceholderAttrConcat(path:number[],name:string,value:(string|number)[]):PlaceHolder {
  if(name.startsWith("_")) name=name.substring(1);
  return {
    path:path,
    CreateOp(node:HTMLElement,curComp:ComponentType,args:any[]):Operation|null {
      let getVal: (args:any[])=>any;
      if((name==="#bind" || name.substr(0,6)==="#bind|") && value.length===2 && typeof value[1]==="string" && value[1].charAt(0)===".") {
        // #bind={obj}.prop
        //getVal=(args:any[])=>MakeRef(args[<number>(value[0])],(<string>(value[1])).substr(1));
        getVal=(args:any[])=>[args[<number>(value[0])] , (<string>(value[1])).substr(1)] //turn it into [Object,propName]
      }  else {
        getVal=(args:any[])=>value.map((p:string|number)=> typeof p==="string" ? p : args[p].toString()).join("");
      }
      return CreateOperationAttr(node,name, getVal, curComp, getVal(args)); 
    }
  }
}

function CreatePlaceholderAttrClasses(path:number[],value:{class:string,argidx:number}[]):PlaceHolder {
  return {
    path:path,
    CreateOp(node:HTMLElement,curComp:ComponentType,args:any[]):Operation|null {
      let getVal=(args:any[])=>{
        let rv="";
        let v:unknown;
        for(let i=0;i<value.length;i++) {
          v=args[value[i].argidx];
          if(typeof v!=="boolean") throw new Error("Katla: class:" + value[i].class + " value must be boolean");
          if(v) rv+=(rv.length>0?" ":"") + value[i].class;
        }
        return rv.length===0 ? false:rv;
      }
      return CreateOperationAttr(node,"class", getVal, curComp, getVal(args)); 
    }
  }
}

function CreatePlaceholderContent(path:number[],varidx:number,single:boolean):PlaceHolder {
  return {
    path:path,
    CreateOp(node:HTMLElement,curComp:ComponentType,args:any[]):Operation|null {
      if(single) return CreateOperationContent( newContent => {
                            node.innerHTML="";
                            if(newContent) node.appendChild(newContent);
                          },varidx,curComp,args[varidx]);
      let NodeEnd=node.nextSibling;
      return CreateOperationContent(newContent => {
        let r:Range=document.createRange();
        r.setStartAfter(node);
        r.setEndBefore(NodeEnd);
        r.deleteContents();
        if(newContent) r.insertNode(newContent);
      },varidx,curComp,args[varidx]);
    }
  };
}
